// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__1EtPo","load7":"styles_load7__Etgw_"};